module.exports = __webpack_public_path__ + "static/media/features-split-image-01.c5f186e8.jpg";